import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { EquipmentConnectionsResponse } from '../../../shared/interfaces/equipment.interfaces';

const basePath = '/equipment/connections';

@Injectable({
  providedIn: 'root',
})
export class EquipmentConnectionsService {
  constructor(private http: HttpClient) {}

  getConnectionHistory(equipmentId: number): Observable<EquipmentConnectionsResponse> {
    return this.http.get<EquipmentConnectionsResponse>(`${basePath}/${equipmentId}`);
  }
}
